var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftM(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.61068 12.1014L16.6523 5.0598C16.8918 4.82029 17.0076 4.53687 16.9996 4.20953C16.9916 3.8822 16.8679 3.59878 16.6284 3.35927C16.3889 3.11976 16.1054 3 15.7781 3C15.4508 3 15.1673 3.11976 14.9278 3.35927L7.57483 10.7362C7.38322 10.9278 7.23951 11.1434 7.14371 11.3829C7.0479 11.6224 7 11.8619 7 12.1014C7 12.341 7.0479 12.5805 7.14371 12.82C7.23951 13.0595 7.38322 13.2751 7.57483 13.4667L14.9518 20.8436C15.1913 21.0831 15.4707 21.1989 15.7901 21.1909C16.1094 21.1829 16.3889 21.0592 16.6284 20.8197C16.8679 20.5802 16.9876 20.2967 16.9876 19.9694C16.9876 19.6421 16.8679 19.3586 16.6284 19.1191L9.61068 12.1014Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftM);
export default __webpack_public_path__ + "static/media/arrow-left-m.1821eaf93b9789d7d240945237589e39.svg";
export { ForwardRef as ReactComponent };